import { NON_EXECUTABLE_FILE_MODE } from "patch-package/dist/patch/parse";
import { useState } from "react";
import styled from "styled-components";

const ToggleWrapper = styled.div`
  display: flex;
  width: fit-content;
  gap: 4px;

  height: 24px;
  padding: 4px;

  border-radius: 6px;
  background: #f2f4f7;

  @media (max-width: 1200px) {
    height: 28px; // 모바일에서 터치 영역 증가
    padding: 2px;
  }
`;

const ToggleItem = styled.div`
  flex: 1;
  padding: 4px 10px;

  border-radius: 4px;
  min-width: fit-content;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: ${(props) => (props.$active === "true" ? "500" : "400")};
  line-height: 16px;
  letter-spacing: 0em;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${(props) => (props.$active === "true" ? "#FFFFFF" : "")};
  color: ${(props) => (props.$active === "true" ? "#000000" : "#191A1A")};
  opacity: ${(props) => (props.$active === "true" ? "1" : "0.4")};
  cursor: pointer;

  @media (max-width: 1200px) {
    padding: 6px 12px; // 터치 영역 증가
    font-size: 10px;
    line-height: 14px;
    min-width: 48px; // 최소 너비 보장
  }

  box-shadow: ${(props) =>
    props.$active === "true" ? " 0px 0px 2px 0px #0000001A" : "0"};
`;

const ToggleComponet = ({
  onClick,
  labels = [
    { name: "시간별", type: "time" },
    { name: "스타일별", type: "style" },
  ],
  initType = undefined,
}) => {
  var givenIndex = labels.findIndex((label) => label.type === initType);
  givenIndex = givenIndex === -1 ? 0 : givenIndex;

  const [activeIndex, setActiveIndex] = useState(labels[givenIndex].type);

  return (
    <ToggleWrapper>
      {labels.map((item, index) => (
        <ToggleItem
          key={index}
          $active={(item.type === activeIndex).toString()}
          onClick={() => {
            setActiveIndex(item.type);
            onClick(item.type);
          }}
        >
          {item.name}
        </ToggleItem>
      ))}
    </ToggleWrapper>
  );
};

export default ToggleComponet;
